
<div class="text-center" *ngIf="invalid">
    <h5>Invalid Access</h5>
</div>
<div *ngIf="!invalid && selectedDepartment" class="account-pages mt-5 mb-5" style="width: 100%;height: 100%">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center" style="display: flex;justify-content:center;">
            <a href="/" class="mb-2 d-block auth-logo">
              <img src="assets/images/navlogo-sm.png" alt="" height="55" class="logo logo-dark">
              <img src="assets/images/navlogo-sm.png" alt="" height="55" class="logo logo-light">
            </a>
          </div>
        </div>
      </div>
    </div>
    <section>
        <div class="container">
          <div class="row">
            <div class="col-12 text-center">
              <div class="home-wrapper">
                <!-- <a routerLink="/" class="mb-5 d-block auth-logo">
                  <img src="assets/images/logo-dark.png" alt="" height="22" class="logo logo-dark">
                  <img src="assets/images/logo-light.png" alt="" height="22" class="logo logo-light">
                </a> -->
      
                <!-- <div class="row justify-content-center">
                  <div class="col-lg-4 col-sm-5">
                    <div class="maintenance-img">
                      <img src="assets/images/maintenance.png" alt="" class="img-fluid mx-auto d-block">
                    </div>
                  </div>
                </div> -->
                <h3 class="mt-1">{{selectedDepartment.departmentName}}</h3>
                <button *ngIf="barcodeValueEmp" class="btn btn-sm btn-outline-danger ms-2" (click)="onLogout()">Logout</button>

                <p></p>
      
                <div class="row">
                    <div class="col-lg-12">
                        <!-- <div class="card"> -->
                            <div>
                                <ngx-step style="background-color: transparent!important;;" [stages]="stages">
                                </ngx-step>
                            </div>
                        <!-- </div> -->
                        <div class="card">
                            <div class="card-body">

                                <div *ngIf="!barcodeValueEmp && this.step == 1" style="text-align: left;">
                                    Please scan your emplyee id barcode to proceed.
                                    <div class="row mt-3">
                                        <div class="col-md-8">
                                            <input
                                                #barcodeInputEmp
                                                type="text"
                                                autofocus
                                                [value]="barcodeValueEmp"
                                                (input)="onInputChangeEmp($event)"
                                                (keydown.enter)="onValueChangesEmpBarcodeReader()"
                                                placeholder="Scan a barcode"
                                                class="form-control"
                                            />

                                            <!-- <input class="form-control" type="text" [value]="barcodeValueEmp"> -->
                                        </div>
                                        <div class="col-md-1" style="display: flex;justify-content: center;align-items: center;">
                                            OR
                                        </div>
                                        <div class="col-md-3">
                                            <button class="btn btn-primary" (click)="startBarcodeSacnner()" type="submit"><i class="fas fa-camera"></i> Scan</button>
                                        </div>
                                    </div>
                                    <div style="width: 300px;margin-top: 20px;">
                                        <barcode-scanner-livestream
                                            type="code_128"
                                            [maxWidth]="50"
                                            [maxWidth]="50"
                                            (valueChanges)="onValueChangesEmpScan($event)"
                                            (started)="(onStarted)"
                                        ></barcode-scanner-livestream>
                                        <div [hidden]="!barcodeValueEmp">
                                        {{ barcodeValueEmp }}
                                      </div>
                                    </div>
                                </div>
                                <div *ngIf="barcodeValueEmp && this.step == 2">
                                    <P style="font-size: 16px;font-weight: bold;margin-bottom: 0px;">{{barcodeValueEmp.name}}</P>
                                    <P style="font-size: 14px;font-weight: bold;">{{barcodeValueEmp.employeeId}}</P>
                                    <hr>
                                    <div class="col-md-12 mb-3" style="text-align: left;">
                                        <div class="row mb-3">
                                            <div class="col-md-3">
                                                <label class="form-check-label" for="customSwitch1">Scan Package Barcode</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="row">
                                                    <div class="col-md-8">
                                                        <input 
                                                        #barcodeInputPkg
                                                        class="form-control" 
                                                        type="text" 
                                                        autofocus
                                                        [value]="barcodeValuePkg"
                                                        (input)="onInputChangePkg($event)"
                                                        (keydown.enter)="onValueChangesPkgBarcodeReader()"
                                                        placeholder="Scan a barcode"
                                                        >
                                                    </div>
                                                    <div class="col-md-1" style="display: flex;justify-content: center;align-items: center;">
                                                        OR
                                                    </div>
                                                    <div class="col-md-3">
                                                        <button class="btn btn-primary" (click)="startBarcodeSacnner()" type="submit"><i class="fas fa-camera"></i> Scan</button>
                                                    </div>
                                                </div>
                                                <!-- <div class="mt-2" *ngIf="!barcodeValuePkg">
                                                    <button class="btn btn-primary" (click)="startBarcodeSacnner()" type="submit">Scan</button>
                                                </div> -->
                                                <div style="width: 300px;margin-top: 20px;" *ngIf="!barcodeValuePkg">
                                                    <barcode-scanner-livestream
                                                        type="code_128"
                                                        [maxWidth]="50"
                                                        [maxWidth]="50"
                                                        (valueChanges)="onValueChangesPkgScan($event)"
                                                        (started)="(onStarted)"
                                                    ></barcode-scanner-livestream>
                                                </div>
                                                <!-- <div [hidden]="!barcodeValuePkg">
                                                    {{ barcodeValuePkg }}
                                                  </div> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="this.step == 3">
                                    <P style="font-size: 16px;font-weight: bold;margin-bottom: 0px;">{{barcodeValueEmp.name}}</P>
                                    <P style="font-size: 14px;font-weight: bold;">{{barcodeValueEmp.employeeId}}</P>
                                    <div style="font-size: 14px;font-weight: 600;margin-bottom: 3px;">
                                       Bundle ID : {{bundleScannedData?.bundleID}}
                                       <span style="padding-left: 10px;">Quantity : {{bundleScannedData?.qty}}</span>
                                    </div>
                                    <hr>
                                    <form [formGroup]="inputQuantityForm" style="text-align: left;"> 
                                        <div class="row mb-3">
                                            <div class="col-md-3">
                                                <label for="patternno">Input Quantity</label>
                                            </div>
                                            <div class="col-md-9">
                                                <input type="number" formControlName="inputQuantity" class="form-control" id="inputQuantity" name="inputQuantity"
                                                    placeholder="Input Quantity"
                                                    [ngClass]="{'is-invalid': inputSubmitted && f.inputQuantity.errors}"
                                                >
                                                <div class="invalid-feedback" *ngIf="inputSubmitted && f.inputQuantity.errors">
                                                    <span>Please provide a valid input quantity.</span>
                                                  </div>
                                            </div>
                                        </div>
                                        <div style="display: flex;justify-content: flex-end;">
                                            <button class="btn btn-primary" (click)="onInputSubmit()" type="submit">Submit</button>
                                        </div>
                                    </form>
                                </div>
                                <div *ngIf="this.step == 4">
                                    <P style="font-size: 16px;font-weight: bold;margin-bottom: 0px;">{{barcodeValueEmp.name}}</P>
                                    <P style="font-size: 14px;font-weight: bold;">{{barcodeValueEmp.employeeId}}</P>
                                    <div style="font-size: 14px;font-weight: 600;margin-bottom: 3px;">
                                       Bundle ID : {{bundleScannedData?.bundleID}}
                                       <span style="padding-left: 10px;">Input Quantity : {{bundleScannedData?.qty}}</span>
                                    </div>
                                    <hr>
                                    <form [formGroup]="outputQuantityForm" style="text-align: left;"> 
                                        <div class="row mb-3">
                                            <div class="col-md-3">
                                                <label for="patternno">Output Quantity</label>
                                            </div>
                                            <div class="col-md-9">
                                                <input type="number" readonly formControlName="outputQuantity" class="form-control" id="outputQuantity" name="outputQuantity"
                                                    placeholder="Ouput Quantity"
                                                    [ngClass]="{'is-invalid': outputSubmitted && fo.outputQuantity.errors}"
                                                >
                                                <div class="invalid-feedback" *ngIf="outputSubmitted && fo.outputQuantity.errors">
                                                    <span>Please provide a valid output quantity.</span>
                                                  </div>
                                            </div>
                                        </div>
                                        <div>
                                            <hr>
                                            <div class="row mb-3">
                                                <p style="color: blue;font-weight: 600;">If the input and output quantities do not match, please adjust the quantities according to the reasons outlined below.</p>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-md-3">
                                                    <label for="patternno">Print Damage Quantity</label>
                                                </div>
                                                <div class="col-md-9">
                                                    <input type="number" formControlName="printDamageQuantity" class="form-control" id="printDamageQuantity" name="printDamageQuantity"
                                                        placeholder="Print Damage Quantity"
                                                    >
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-md-3">
                                                    <label for="patternno">Fabric Damage Quantity</label>
                                                </div>
                                                <div class="col-md-9">
                                                    <input type="number" formControlName="fabricDamageQuantity" class="form-control" id="fabricDamageQuantity" name="fabricDamageQuantity"
                                                        placeholder="Fabric Damage Quantity"
                                                    >
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-md-3">
                                                    <label for="patternno">Sample Quantity</label>
                                                </div>
                                                <div class="col-md-9">
                                                    <input type="number" formControlName="sampleQuantity" class="form-control" id="sampleQuantity" name="sampleQuantity"
                                                        placeholder="Sample Quantity"
                                                    >
                                                </div>
                                            </div>
                                            <hr>
                                        </div>
                                        <div style="display: flex;justify-content: flex-end;">
                                            <button class="btn btn-primary" (click)="onOutputSubmit()" type="submit">Submit</button>
                                        </div>
                                    </form>
                                </div>
                                <div *ngIf="this.step == 5">
                                    <ngb-alert type="success" [dismissible]="false">
                                        You have successfully completed the flow.
                                    </ngb-alert>
                                    <div class="mt-5" style="display: flex;justify-content: center">
                                        <button class="btn btn-primary" (click)="onReload();" type="submit">Reload</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end row -->
              </div>
            </div>
          </div>
        </div>
    </section>
</div>




<!-- <div class="container-fluid">
    <app-page-title title="Barcode Reader" [breadcrumbItems]="breadCrumbItems"></app-page-title>
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div *ngIf="!barcodeValueEmp">
                        Please scan your emplyee id barcode to proceed.
                        <div class="row mt-3">
                            <div class="col-md-4">
                                <input class="form-control" type="text" [value]="barcodeValueEmp">
                            </div>
                            <div class="col-md-1" style="display: flex;justify-content: center;align-items: center;">
                                OR
                            </div>
                            <div class="col-md-4">
                                <button class="btn btn-primary" (click)="startBarcodeSacnner()" type="submit"><i class="fas fa-camera"></i> Scan</button>
                            </div>
                        </div>
                        <div style="width: 300px;margin-top: 20px;">
                            <barcode-scanner-livestream
                                type="code_128"
                                [maxWidth]="50"
                                [maxWidth]="50"
                                (valueChanges)="onValueChangesEmp($event)"
                                (started)="(onStarted)"
                            ></barcode-scanner-livestream>
                            <div [hidden]="!barcodeValueEmp">
                            {{ barcodeValueEmp }}
                          </div>
                        </div>
                    </div>
                    <div *ngIf="barcodeValueEmp">
                        <P style="font-size: 18px;font-weight: bold;">Emp ID : {{barcodeValueEmp}}</P>
                        <hr>
                        <div class="col-md-12 mb-3">
                            <div class="row mb-3">
                                <div class="col-md-3">
                                    <label class="form-check-label" for="customSwitch1">Scan Package Barcode</label>
                                </div>
                                <div class="col-md-9">
                                    <div class="row" *ngIf="!barcodeValuePkg">
                                        <div class="col-md-4">
                                            <input class="form-control" type="text" [value]="barcodeValuePkg">
                                        </div>
                                        <div class="col-md-1" style="display: flex;justify-content: center;align-items: center;">
                                            OR
                                        </div>
                                        <div class="col-md-4">
                                            <button class="btn btn-primary" (click)="startBarcodeSacnner()" type="submit"><i class="fas fa-camera"></i> Scan</button>
                                        </div>
                                    </div>
                                    <div style="width: 300px;margin-top: 20px;" *ngIf="!barcodeValuePkg">
                                        <barcode-scanner-livestream
                                            type="code_128"
                                            [maxWidth]="50"
                                            [maxWidth]="50"
                                            (valueChanges)="onValueChangesPkg($event)"
                                            (started)="(onStarted)"
                                        ></barcode-scanner-livestream>
                                    </div>
                                    <div [hidden]="!barcodeValuePkg">
                                        {{ barcodeValuePkg }}
                                      </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-3">
                                    <label for="patternno">Input Quantity</label>
                                </div>
                                <div class="col-md-9">
                                    <input type="number" class="form-control" id="inputQuantity" name="inputQuantity"
                                        placeholder="Input Quantity"
                                    >
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-3">
                                    <label for="patternno">Output Quantity</label>
                                </div>
                                <div class="col-md-9">
                                    <input type="number" class="form-control" id="outputQuantity" name="outputQuantity"
                                        placeholder="Output Quantity"
                                    >
                                </div>
                            </div>
                            <div style="display: flex;justify-content: flex-end;">
                                <button class="btn btn-primary" (click)="onSubmit()" type="submit">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->